import React from 'react';
import { useParams, useNavigate } from 'react-router';
import ProjectJiraItems from '../components/projects/ProjectJiraItems';
import { AppShell } from '../components/layout';
import { useWorkspace } from '../context/WorkspaceContext';
import { buildWorkspaceDashboardPath } from '../utils/workspaceRouteUtils';

const ProjectJiraItemsPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { currentWorkspace } = useWorkspace();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const handleBack = () => {
    const workspaceId = currentWorkspace?.id;
    if (workspaceId && id) {
      navigate(buildWorkspaceDashboardPath(workspaceId, id));
      return;
    }
    if (workspaceId) {
      navigate(buildWorkspaceDashboardPath(workspaceId, null, 'projects'));
      return;
    }
    navigate('/dashboard/all-workspaces');
  };

  return (
    <AppShell
      user={user}
      onLogout={() => {
        localStorage.removeItem('isAuthenticated');
        localStorage.removeItem('user');
        navigate('/auth/login');
      }}
    >
      <ProjectJiraItems project={{ id }} onClose={handleBack} />
    </AppShell>
  );
};

export default ProjectJiraItemsPage;
